import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import HomeCurvedText from "./HomeCurvedText";
import { Grid, useMediaQuery, Button, Typography } from "@mui/material";
//import rightcorner from "assets/images/rightcorner.png";
// import leftcorner from "assets/images/leftcorner.svg";
import { LeftCustomSvgIcon, RightCustomSvgIcon } from "helpers/CustomSVGGauge";
import ShareHCPApp from "pages/home/ShareHCPApp";

const LandingGauge = (props) => {
  const { organizationInfo } = props;
  const [retailGauge, setRetailGauge] = useState(false);
  const [text, setText] = useState(false);
  const [discountGauge, setDiscountGauge] = useState(false);
  const [copayGauge, setCopayGauge] = useState(false);
  const [couponGauge, setCouponGauge] = useState(false);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const matchesMinWidth = useMediaQuery("(max-width:500px)");
   const isHCPTemplate =
     organizationInfo?.type?.toLowerCase() === "h" &&
     organizationInfo?.app?.appCode?.toLowerCase() == "hcp";
  
  const widgetEnabled = sessionStorage.getItem("widgetEnabled");

  const showGaugeFlag =
    organizationInfo?.organizationOptionJson?.showGaugeFlag?.toLowerCase() ===
    "y";

  const resetGauge = () => {
    setRetailGauge(false);
    setDiscountGauge(false);
    setCopayGauge(false);
    setCouponGauge(false);
  };

  useEffect(() => {
    setTimeout(() => {
      resetGauge();
    }, 100);
    setTimeout(() => {
      if (organizationInfo?.organizationOptionJson?.gaugeInfoText?.retail) {
        setText(
          organizationInfo?.organizationOptionJson?.gaugeInfoText?.retail
        );
      }

       setRetailGauge(true);
     }, 2500);
     setTimeout(() => {
       if (organizationInfo?.organizationOptionJson?.gaugeInfoText?.discount) {
         setText(
           organizationInfo?.organizationOptionJson?.gaugeInfoText?.discount
         );
       }
       setDiscountGauge(true);
     }, 5000);
     setTimeout(() => {
       if (organizationInfo?.organizationOptionJson?.gaugeInfoText?.copay) {
         setText(
           organizationInfo?.organizationOptionJson?.gaugeInfoText?.copay
         );
       }
       setCopayGauge(true);
     }, 7500);
     setTimeout(() => {
       if (organizationInfo?.organizationOptionJson?.gaugeInfoText?.coupon) {
         setText(
           organizationInfo?.organizationOptionJson?.gaugeInfoText?.coupon
         );
       }
       setCouponGauge(true);
       setTimeout(() => {
         setText("");
       }, 3000);
     }, 10000);
   }, []);

  const hcpShareBtn = () => {
    return (
      <Grid
        sx={{
          zIndex: 1,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          variant="filled"
          id="navSignUp"
          sx={{
            fontSize: "18px",
            width: "100%",

            "&:hover": {
              opacity: 1,
              // backgroundColor:
              //   isShowBackgroundAssets && !matches
              //     ? `#003d4c !important`
              //     : undefined,
              // color:
              //   isShowBackgroundAssets && !matches
              //     ? `#fff !important`
              //     : undefined,
            },
          }}
          onClick={() => {
            setShowSharePopup(true);
          }}
        >
          SEND SITE TO PATIENT
        </Button>
      </Grid>
    );
  };

  return (
    <>
      <div
        className="donut-graph"
        style={{
          zIndex: 0,
          width: matchesMinWidth ? "280px" : "25rem",
          marginTop: "-40px",
        }}
      >
        {text && organizationInfo?.organizationOptionJson?.gaugeInfoText && (
          <div
            id="dynamic-text"
            style={{
              display: "flex",
              alignItems: "end",
              justifyContent: "center",
              color: "red",
              zIndex: "10000000000",
              position: "relative",
              height: "100%",
              padding: "25%",
              paddingTop: matchesMinWidth ? "67%" : "43%",
            }}
          >
            <Typography
              variant="h1LatoBold"
              component={"div"}
              sx={{
                width: "75%",
                color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                fontSize: matchesMinWidth ? "14px" : "20px",
                textAlign: "center",
              }}
            >
              {text}
            </Typography>
          </div>
        )}
        {showGaugeFlag && (
          <>
            {couponGauge ? (
              <div
                className="semi-donut"
                style={{
                  "--degree": 180,
                  "--donutBorder": `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge4Color}`,
                  "--top": "40%",
                  "--left": "-28%",
                  "--transform": "-116deg",
                  "--animation": "1s",
                  width: matchesMinWidth ? "280px" : "25rem",
                  height: matchesMinWidth ? "140px" : "12.5rem",
                  borderWidth: matchesMinWidth ? "4.2rem" : "5rem",
                  borderBottomWidth: matchesMinWidth ? "4.1rem" : "4.999999rem",
                }}
              ></div>
            ) : null}
            {couponGauge ? (
              <HomeCurvedText
                title="COUPON"
                titleColor={`${organizationInfo?.colorSchemeJson?.gaugeColor?.wedgeTextColor}`}
                bottom={matchesMinWidth ? 8 : 35}
                unicode="&#8224;"
                right={matchesMinWidth ? -6 : -21}
                fontSize={matchesMinWidth ? 23 : 22}
                textStartPoint={18}
                degree={70}
              />
            ) : null}
            {copayGauge ? (
              <HomeCurvedText
                titleColor={`${organizationInfo?.colorSchemeJson?.gaugeColor?.wedgeTextColor}`}
                title="EST. COPAY"
                top={matchesMinWidth ? 69 : 11}
                right={matchesMinWidth ? 53 : 70}
                fontSize={matchesMinWidth ? 22 : 21}
                degree={matchesMinWidth ? 23 : 23}
                textStartPoint={18}
              />
            ) : null}
            {copayGauge ? (
              <div
                className="semi-donut"
                style={{
                  "--degree": 135,
                  "--donutBorder": `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge3Color}`,
                  "--top": "41%",
                  "--left": "-33%",
                  "--transform": "-111deg",
                  "--animation": "2s",
                  width: matchesMinWidth ? "280px" : "25rem",
                  height: matchesMinWidth ? "140px" : "12.5rem",
                  borderWidth: matchesMinWidth ? "4.2rem" : "5rem",
                }}
              ></div>
            ) : null}
            {discountGauge ? (
              <div
                className="semi-donut"
                style={{
                  "--degree": 90,
                  "--donutBorder": `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge2Color}`,
                  "--top": "43%",
                  "--left": "-30%",
                  "--transform": "-116deg",
                  "--animation": "3s",
                  width: matchesMinWidth ? "280px" : "25rem",
                  height: matchesMinWidth ? "140px" : "12.5rem",
                  borderWidth: matchesMinWidth ? "4.2rem" : "5rem",
                  borderBottomWidth: matchesMinWidth ? "4.1rem" : "4.999999rem",
                }}
              ></div>
            ) : null}
            {discountGauge ? (
              <HomeCurvedText
                title="DISCOUNT"
                titleColor={`${organizationInfo?.colorSchemeJson?.gaugeColor?.wedgeTextColor}`}
                textStartPoint={matchesMinWidth ? 16 : 16}
                left={matchesMinWidth ? 52 : 67}
                top={matchesMinWidth ? 70 : 11}
                fontSize={matchesMinWidth ? 23 : 21}
                degree={matchesMinWidth ? 336 : 337}
              />
            ) : null}
            {retailGauge ? (
              <HomeCurvedText
                left={matchesMinWidth ? -5 : -21}
                title="RETAIL"
                titleColor={`${organizationInfo?.colorSchemeJson?.gaugeColor?.wedgeTextColor}`}
                textStartPoint={32}
                bottom={matchesMinWidth ? 11 : 39}
                fontSize={matchesMinWidth ? 23 : 22}
                degree={matchesMinWidth ? 292 : 292}
              />
            ) : null}
            {retailGauge ? (
              <div
                className="semi-donut"
                style={{
                  "--degree": 45,
                  "--donutBorder": `${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge1Color}`,
                  "--top": "44%",
                  "--left": "-24%",
                  "--transform": "-116deg",
                  "--animation": "1s",
                  width: matchesMinWidth ? "280px" : "25rem",
                  height: matchesMinWidth ? "140px" : "12.5rem",
                  borderWidth: matchesMinWidth ? "4.2rem" : "5rem",
                }}
              ></div>
            ) : null}

            <RightCustomSvgIcon
              className={
                matchesMinWidth ? "mobile-right-curved-arc" : "right-curved-arc"
              }
              color={`${organizationInfo?.colorSchemeJson?.gaugeColor?.backgroundColor}`}
            />
            {/* <img
          src={rightcorner}
          alt="righarc"
          className={
            matchesMinWidth ? "mobile-right-curved-arc" : "right-curved-arc"
          }
        /> */}

            <LeftCustomSvgIcon
              className={
                matchesMinWidth ? "mobile-left-curved-arc" : "left-curved-arc"
              }
              color={`${organizationInfo?.colorSchemeJson?.gaugeColor?.backgroundColor}`}
            />

            {/* <img
          src={leftcorner}
          alt="righarc"
          className={
            matchesMinWidth ? "mobile-left-curved-arc" : "left-curved-arc"
          }
        /> */}
          </>
        )}
      </div>
      {isHCPTemplate
        ? organizationInfo?.organizationOptionJson?.hideSendSiteToPatient ===
            null ||
          organizationInfo?.organizationOptionJson?.hideSendSiteToPatient.toLowerCase() ===
            "n"
          ? hcpShareBtn()
          : widgetEnabled?.toLowerCase() === "n"
          ? hcpShareBtn()
          : null
        : null}
      {showSharePopup && (
        <ShareHCPApp
          setShowSharePopup={setShowSharePopup}
          shareCoupon={false}
          shareApp={showSharePopup}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data,
  };
};

export default connect(mapStateToProps)(LandingGauge);